import { PropsWithChildren } from 'react';
import { ErrorMessage, ErrorHarness as StyledErrorHarness } from './ErrorHarness.styles';

export type ErrorHarnessProps = PropsWithChildren<{
  errorMessage?: string | string[];
  className?: string;
}>;

export const ErrorHarness = ({ errorMessage: error, children, className }: ErrorHarnessProps) => {
  const errors = typeof error === 'string' ? [error] : error;
  return (
    <StyledErrorHarness className={className}>
      {children}
      {errors && errors.map((error, index) => <ErrorMessage key={index}>{error}</ErrorMessage>)}
    </StyledErrorHarness>
  );
};
